import React from 'react';
import THEME from '../utils/theme';
import Loader from '../components/Loader';
import useFetch from '../hooks/useFetch';
import useInView from '../hooks/useInView';
import { FaExclamationCircle, FaInfoCircle, FaClipboardList } from 'react-icons/fa';

export default function Notices() {
  const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
  const { data: notices, loading } = useFetch(`${API_BASE}/notices`);
  const [ref, visible] = useInView();
  const active = notices.filter(n => n.isActive);

  return (
    <section id="notices" style={{ padding: '100px clamp(20px,4vw,40px)', background: THEME.navy }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div ref={ref} className={`sk-fade-up ${visible ? 'sk-visible' : ''}`}>
          <div style={{
            display: 'inline-flex', alignItems: 'center', gap: 8,
            background: `${THEME.red}30`, border: `1px solid ${THEME.red}50`,
            color: '#FF8096', fontSize: 11, fontWeight: 700, letterSpacing: '0.12em',
            textTransform: 'uppercase', padding: '6px 16px', borderRadius: 2, marginBottom: 20,
            fontFamily: "'Syne', sans-serif",
          }}>
            <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#FF8096', display: 'inline-block', animation: 'pulse-dot 1.8s infinite' }} />
            Notice Board
          </div>
          <h2 style={{ fontFamily: "'Syne', sans-serif", fontWeight: 800, fontSize: 'clamp(2rem,4vw,3.2rem)', lineHeight: 1.1, color: 'white' }}>
            Latest Announcements
          </h2>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, margin: '16px 0 48px' }}>
            <span style={{ fontFamily: "'Noto Serif',serif", fontSize: 13, color: 'rgba(255,255,255,0.2)', letterSpacing: '0.1em' }}>お知らせ</span>
            <div style={{ flex: 1, height: 1, background: `linear-gradient(90deg, ${THEME.red}40, transparent)` }} />
          </div>
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', padding: 60, color: 'rgba(255,255,255,0.4)' }}>Loading...</div>
        ) : active.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 60, color: 'rgba(255,255,255,0.3)' }}>
            <FaClipboardList size={48} style={{ margin: '0 auto 12px', display: 'block', opacity: 0.4 }} />
            <p>No notices at this time</p>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            {active.map((n, i) => (
              <div key={n._id}
                className={`sk-fade-up ${visible ? 'sk-visible' : ''}`}
                style={{
                  transitionDelay: `${i * 0.07}s`,
                  background: 'rgba(255,255,255,0.05)',
                  border: `1px solid ${n.isImportant ? `${THEME.red}60` : 'rgba(255,255,255,0.08)'}`,
                  borderLeft: `4px solid ${n.isImportant ? THEME.red : 'rgba(255,255,255,0.15)'}`,
                  borderRadius: '0 8px 8px 0', padding: '20px 28px',
                  display: 'flex', alignItems: 'flex-start', gap: 20,
                }}>
                <div style={{ flexShrink: 0, paddingTop: 2 }}>
                  <span style={{
                    background: n.isImportant ? THEME.red : 'rgba(255,255,255,0.1)',
                    color: n.isImportant ? 'white' : 'rgba(255,255,255,0.5)',
                    fontSize: 10, fontWeight: 700, padding: '4px 10px', borderRadius: 2,
                    letterSpacing: '0.08em', fontFamily: "'Syne', sans-serif",
                    display: 'flex', alignItems: 'center', gap: 5,
                  }}>
                    {n.isImportant
                      ? <><FaExclamationCircle size={11} /> URGENT</>
                      : <><FaInfoCircle size={11} /> GENERAL</>
                    }
                  </span>
                </div>
                <div style={{ flex: 1 }}>
                  <h4 style={{ fontFamily: "'Syne', sans-serif", fontSize: 16, fontWeight: 700, color: 'white', marginBottom: 6 }}>
                    {n.title}
                  </h4>
                  <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.6)', lineHeight: 1.7 }}>{n.description}</p>
                </div>
                <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.28)', flexShrink: 0, fontFamily: "'Syne', sans-serif" }}>
                  {new Date(n.createdAt).toLocaleDateString('en-GB')}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
